import React, { useEffect, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import debounce from "lodash.debounce";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentsThunk } from "../../../modules/documents/documentOperations";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import {
  documentActions,
  documentSelectors,
} from "../../../modules/documents/documentsSlice";

function DocumentSearchInput() {
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const documentTextSearch = useSelector(documentSelectors.selectTextSearch);

  // Create a debounced fetch function that persists across renders
  const debouncedFetch = useRef(
    debounce((text) => {
      dispatch(
        fetchDocumentsThunk({
          params: {
            sort: `["createdAt","ASC"]`,
            filter: { fulltext: text },
          },
        }),
      );
    }, 500),
  ).current;

  // Trigger the debounced fetch whenever the search text changes
  useEffect(() => {
    debouncedFetch(documentTextSearch);
  }, [documentTextSearch, debouncedFetch]);

  const handleChange = (event) => {
    const val = event.target.value;
    dispatch(documentActions.setTextSearch(val));
  };

  return (
    <TextField
      fullWidth
      size="large"
      variant="outlined"
      placeholder={formatMessage({ id: "search.input.placeholder" })}
      value={documentTextSearch}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}

export default DocumentSearchInput;
